<ion-header>
  <ion-toolbar>
    <ion-title>image-gallery</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <fiv-gallery>
    <fiv-gallery-toolbar position="top">
      <fiv-gallery-toolbar-content></fiv-gallery-toolbar-content>
    </fiv-gallery-toolbar>
    <ion-grid >
      <ion-row>
        <ion-col *ngFor="let pic of product_info.product_images;index as i" size="6" (click)="get_img('')" [id]="i + 'd'" sizeMd="4">
          <fiv-gallery-image class="gallery" [id]="i + 's'"  [src]="pic.detail_thumbnail"></fiv-gallery-image>
        </ion-col>
      </ion-row>
    </ion-grid>
  </fiv-gallery>
</ion-content>
